import { Route, Routes } from 'react-router-dom';

import { PasswordLogin } from './PasswordLogin';
import { SetupExtraSecurityLayers } from './SetupExtraSecurityLayers';
import { GoogleAuthLogin } from './GoogleAuthLogin';
import { EmailOTPLogin } from './EmailOTPLogin';
import { SMSOTPLogin } from './SMSOTPLogin';
import { GoogleAuthSetup } from './GoogleAuthSetup';
import { EmailOTPSetup } from './EmailOTPSetup';
import { SMSOTPSetup } from './SMSOTPSetup';

export const AuthenticationRoutes = () => {
  return (
    <Routes>
      <Route path="login" element={<PasswordLogin />} />
      <Route path="security/authenticator" element={<GoogleAuthLogin />} />
      <Route
        path="security/authenticator/setup"
        element={<GoogleAuthSetup />}
      />
      <Route path="security/email" element={<EmailOTPLogin />} />
      <Route path="security/email/setup" element={<EmailOTPSetup />} />
      <Route path="security/sms" element={<SMSOTPLogin />} />
      <Route path="security/sms/setup" element={<SMSOTPSetup />} />
      <Route
        path="security/setup-required"
        element={<SetupExtraSecurityLayers />}
      />
      {/* <Route path="*" element={<Navigate to="." />} /> */}
    </Routes>
  );
};
